module.exports = __webpack_public_path__ + "bg2.d3864fe4ef1ba216c187.png";


//////////////////
// WEBPACK FOOTER
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/assets/img/bg2.png
// module id = ../../../../../src/assets/img/bg2.png
// module chunks = styles